<template>
  <div id="app">
    <vue-winwheel :segments="options" :token="token" />
  </div>
</template>

<script>
import VueWinwheel from "@/vue-winwheel";

export default {
  name: "app",
  components: {
    VueWinwheel
  },
  data() {
    return {
      options: [
        {
          // textFillStyle: "#fff",
          image: window.location.protocol + "//" + location.host + "/img/1.png", 
          fillStyle: "#000",
          text: "Prize 1"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/2.png",
          fillStyle: "#fadede",
          text: "Prize 2"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/3.png",
          fillStyle: "#000",
          text: "Prize 3"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/4.png",
          fillStyle: "#fadede",
          text: "Prize 4"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/5.png",
          fillStyle: "#000",
          text: "Prize 5"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/6.png",
          fillStyle: "#fadede",
          text: "Prize 6"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/7.png",
          fillStyle: "#000",
          text: "Prize 7"
        },
        {
          image: window.location.protocol + "//" + location.host + "/img/8.png",
          fillStyle: "#fadede",
          text: "Prize 9"
        }
      ],
      token: this.$root.$route.query.token
    };
  }
};
</script>

<style>
@font-face {
  font-family: "Brown" ;
  src:  url('./assets/font/brown/Brown-Regular1.otf')  format("opentype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "Brown" ;
  src:  url('./assets/font/brown/Brown-Bold1.otf')  format("opentype");
  font-weight: bold;
  font-style: normal;
}
#app {
  font-family: "Brown";
  /* font-family: "Brown" ; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: url('./assets/img/background.png');
  width: 100vw;
  background-size: cover;
  padding: 50px 0;
}
body {
  margin: 0;
}
</style>
